var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91699 16.5003C1.58366 16.5003 1.29199 16.3753 1.04199 16.1253C0.791992 15.8753 0.666992 15.5837 0.666992 15.2503V5.25033C0.666992 4.91699 0.791992 4.62533 1.04199 4.37533C1.29199 4.12533 1.58366 4.00033 1.91699 4.00033H5.66699V1.91699C5.66699 1.58366 5.79199 1.29199 6.04199 1.04199C6.29199 0.791992 6.58366 0.666992 6.91699 0.666992H11.0837C11.417 0.666992 11.7087 0.791992 11.9587 1.04199C12.2087 1.29199 12.3337 1.58366 12.3337 1.91699V4.00033H16.0837C16.417 4.00033 16.7087 4.12533 16.9587 4.37533C17.2087 4.62533 17.3337 4.91699 17.3337 5.25033V15.2503C17.3337 15.5837 17.2087 15.8753 16.9587 16.1253C16.7087 16.3753 16.417 16.5003 16.0837 16.5003H1.91699ZM1.91699 15.2503H16.0837V5.25033H1.91699V15.2503ZM6.91699 4.00033H11.0837V1.91699H6.91699V4.00033Z",
    fill: "#0129FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector7.125357f6847394cab21fb60ae1976753.svg";
export { ForwardRef as ReactComponent };